<template>
    <div></div>
</template>

<script>
import { getQueryString, httpPostSecret } from "@/utils/utils"
export default {
    name: "logout",
    data() {
        return {
            ddd: ''
        }
    },
    mounted() {
        this.fetchCallback()
    },
    methods: {
        async fetchCallback() {
            // 如果有href,跳href；如果没有href，跳res.data
            const url = "/api/user/logout"
            const res = await httpPostSecret(url)

            if (res.rspCode !== '000000') {
                this.$message.error(res.rspMsg);
                return
            }
            this.nextStep()
        },
        nextStep() {
            // http://172.16.1.139:8080/logout?callback=https://baidu.com
            // 这种格式，就跳到login页面之后，带上callback参数，然后直接在login页面上登录成功过之后，直接跳转到callback地址。如果没有callback,就跳转res.data地址
            const callback = getQueryString('callback')
            const suffix = callback ? `?callback=${callback}` : ''
            location.replace(process.env.VUE_APP_BASE_URL + "index" + suffix)
        }
    }
}
</script>

<style lang="less"></style>
